import * as React from 'react';

export interface SelectGroupItemProps {
  children: React.ReactNode;
  title?: string;
  icon?: React.ReactNode;
  hidden?: boolean;
  selected?: boolean;
}

export const SelectGroupItem = (props: SelectGroupItemProps) => <>{props.children}</>;

export interface SelectGroupItemWithIdProps extends SelectGroupItemProps {
  id: string;
}

export const SelectGroupItemWithId = (props: SelectGroupItemWithIdProps) => <>{props.children}</>;
